// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1rHS7","errors":"Errors_errors__qEalb"};